module.exports = __webpack_public_path__ + "media/landing_page/instacart-eataly-lockup-450ccd46.svg";